
import Vue from 'vue'
import UserTransformer from '@/transformers/users'

/**
 * @author Suhipney Romero. <suhiipney@gmail.com>
 * Fetches all register users
 * @return {Array} An Array with all register users
 */

export default () =>
  Vue.$http.get(`users/`)
    .then(response => UserTransformer.fetchCollection( response.data))
